import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const formatDate = (date?: string | null) => {
  console.log(date);
  if (!date) return "";

  // Extract just the date part (YYYY-MM-DD) to avoid timezone conversion issues
  const dateOnly = date.split('T')[0];
  const parts = dateOnly.split('-');
  if (parts.length !== 3) return "";

  const [year, month, day] = parts.map(Number);
  if (!year || !month || !day) return "";

  // Create date using local date components (no timezone conversion)
  const d = new Date(year, month - 1, day);
  if (Number.isNaN(d.getTime())) return "";

  return d.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: "America/New_York",
  });
};

export const formatLocalizedDate = (date?: string | null, language?: string | null) => {
  console.log('formatLocalizedDate called with:', { date, language });
  if (!date) return "";

  const dateOnly = date.split('T')[0];
  const parts = dateOnly.split('-');
  if (parts.length !== 3) return "";

  const [year, month, day] = parts.map(Number);
  if (!year || !month || !day) return "";

  const d = new Date(year, month - 1, day);
  if (Number.isNaN(d.getTime())) return "";

  const locale = language === "French" ? "fr-FR" : "en-US";
  console.log('Using locale:', locale);
  const formatted = d.toLocaleDateString(locale, {
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: "America/New_York",
  });
  console.log('Formatted date:', formatted);
  return formatted;
};